import React from "react";

function HideTool(props) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.775 23.125L17.5 20.85C16.6833 21.3833 15.8125 21.7917 14.8875 22.075C13.9625 22.3583 13 22.5 12 22.5C10.6167 22.5 9.31667 22.2375 8.1 21.7125C6.88333 21.1875 5.825 20.475 4.925 19.575C4.025 18.675 3.3125 17.6167 2.7875 16.4C2.2625 15.1833 2 13.8833 2 12.5C2 11.5 2.14167 10.5375 2.425 9.6125C2.70833 8.6875 3.11667 7.81667 3.65 7L1.375 4.725L2.8 3.3L21.2 21.7L19.775 23.125ZM12 20.5C12.7167 20.5 13.4125 20.4083 14.0875 20.225C14.7625 20.0417 15.4167 19.7667 16.05 19.4L5.1 8.45C4.73333 9.08333 4.45833 9.7375 4.275 10.4125C4.09167 11.0875 4 11.7833 4 12.5C4 14.7167 4.77917 16.6042 6.3375 18.1625C7.89583 19.7208 9.78333 20.5 12 20.5ZM20.35 18L18.9 16.55C19.2667 15.9167 19.5417 15.2625 19.725 14.5875C19.9083 13.9125 20 13.2167 20 12.5C20 10.2833 19.2208 8.39583 17.6625 6.8375C16.1042 5.27917 14.2167 4.5 12 4.5C11.2833 4.5 10.5875 4.59167 9.9125 4.775C9.2375 4.95833 8.58333 5.23333 7.95 5.6L6.5 4.15C7.31667 3.61667 8.1875 3.20833 9.1125 2.925C10.0375 2.64167 11 2.5 12 2.5C13.3833 2.5 14.6833 2.7625 15.9 3.2875C17.1167 3.8125 18.175 4.525 19.075 5.425C19.975 6.325 20.6875 7.38333 21.2125 8.6C21.7375 9.81667 22 11.1167 22 12.5C22 13.5 21.8583 14.4625 21.575 15.3875C21.2917 16.3125 20.8833 17.1833 20.35 18Z"
        fill="#E8EAED"
      />
    </svg>
  );
}

export default HideTool;
